export default "__VITE_ASSET__D6letKI9__"